const SALIDAS_TRASLADO = (state, salidas_traslado) => {
    state.salidas_traslado = salidas_traslado;
};

const PARA_ENTRADA_POR_TRASLADO = (state, para_entrada_por_traslado) => {
    state.salidas_traslado = para_entrada_por_traslado;
};

export default {
    SALIDAS_TRASLADO,
    PARA_ENTRADA_POR_TRASLADO,

};
